/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


export default class ColonyCass extends Logic
{
  getCoreSector ()
  {
    return this.object.getSector(this.cass.id);
  }


  hasCoreSector ()
  {
    return this.cass.user === this.getCoreSector().cass.currentUser;
  }


  getScoreFraction (date)
  {
    const duration = this.object.parent.getSettings().getBoardScoreDuration();

    return Math.min(duration, date - this.cass.attachDate) / duration;
  }


};
